module.exports = __webpack_public_path__ + "static/logo-kunera-white-187ca13b5b98da0801446df38b239c53.svg";